import { IColumns } from '../../../components/Table'

export enum TradingStatus {
  Executed = 'Executed',
  Cancelled = 'Cancelled',
  Open = 'Open',
}

export interface IData {
  timestamp: 'string'
  buy?: number
  sell?: number
}

export type TradesColumnsType =
  | 'id'
  | 'timestamp'
  | 'pair'
  | 'asset'
  | 'type'
  | 'quantity'
  | 'price'
  | 'notional'
  | 'fee'
  | 'group'
  | 'counterparty'
  | 'companyName'
  | 'status'

export const columns: IColumns<TradesColumnsType>[] = [
  {
    id: 'id', // idSf заменить
    label: 'ID',
  },
  {
    id: 'timestamp',
    label: 'TIME STAMP',
    format: (value) => value && new Date(value as Date).toLocaleString('en-GB'),
  },
  {
    id: 'pair',
    label: 'PAIR',
  },
  {
    id: 'asset',
    label: 'ASSET',
  },
  {
    id: 'type',
    label: 'TYPE',
  },
  {
    id: 'quantity',
    label: 'QTY',
  },
  {
    id: 'price',
    label: 'PRICE',
  },
  {
    id: 'notional',
    label: 'NOTIONAL',
  },
  {
    id: 'fee',
    label: 'FEE',
  },
  // {
  //   id: 'group',
  //   label: 'GROUP',
  // },
  // {
  //   id: 'counterparty',
  //   label: 'COUNTERPARTY',
  // },
  {
    id: 'companyName',
    label: 'COMPANY',
  },
  {
    id: 'status',
    label: 'STATUS',
  },
]
